/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppRequestCreateMutationVariables = Types.Exact<{
  appRequestParams: Types.IAppRequestParams;
}>;

export type IAppRequestCreateMutation = {
  __typename?: 'Mutation';
  appRequestCreate?: {
    __typename?: 'AppRequestCreatePayload';
    errors?: Array<string> | null;
    success: boolean;
    appRequest?: {
      __typename?: 'AppRequest';
      id: string;
      appName?: string | null;
      contactEmail: string;
      contactName: string;
      description: string;
      declineReason?: string | null;
      status: Types.AppRequestStatusEnum;
      requesterCompanyName: string;
      requesterCompanyWebsite: string;
      vendorName: string;
      policy: { __typename?: 'AppRequestPolicy'; accept: boolean; decline: boolean };
    } | null;
  } | null;
};

export const AppRequestCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'appRequestCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appRequestParams' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppRequestParams' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appRequestCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'appRequestParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appRequestParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'appRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppRequestFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppRequestFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AppRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'appName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declineReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accept' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decline' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requesterCompanyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requesterCompanyWebsite' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vendorName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppRequestCreateMutation, IAppRequestCreateMutationVariables>;
